<template>
    <mks-spacer class="related">
      <mks-text weight="bold"
        >{{__("D'autres évènements qui pourraient vous intéresser")}}</mks-text
      >
     <div class="related__list mks-grid" v-if="events && events.length > 0"> 
       <EventCard
        v-for="event in events"
        :key="event._id"
        :event="event"
        layout="simple"
        class="mks-col-12 mks-col-5@sm mks-col-4@md"
        source="related-events"
      ></EventCard>
     </div>
    </mks-spacer>
</template>
<script>
export default {
    props: {
        events: Array
    },
}
</script>
<style lang='scss' scoped>
.related__list {
  --grid-gap: var(--space-m);
}
</style>